<template>
    <section :class="{seven3css: seven3theme==='seven3css'}">
        <div class="container">
            <div class="row align-items-start">
              <div class="col-xs-12 col-sm-12 col-md-8 collarge">              
                 <div v-html="LeftsideText"></div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 colsmall">
                <div v-html="RightsideText" class="card shadow pushsection"></div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import BreadCrumbs from '@/components/BreadCrumbs.vue';
export default {
    props: ['LeftsideText', 'RightsideText', 'leftsectheme', 'seven3theme'],
}
</script>
<style scoped>
.container {
padding-top: 100px;
padding-bottom: 100px;
}
.pushsection {
    margin-top: -100px;
    background-color: white;
    padding: 30px;
}



/*===================MEDIA SCREENS TAMPLATES===============*/
  /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .colsmall {
    width: 100%;
    padding-top: 200px;
  }
  .collarge {
    padding-left: 20px;
    padding-right: 20px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }
  .formatsdgs {
      padding-left: 20px;
      padding-right: 20px;
  }
 }
    
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .colsmall {
    width: 100%;
    padding-top: 200px;
  }
  .collarge {
    padding-left: 10px;
    padding-right: 10px;
  }
  .txtdata {
    margin-bottom: 100px;
    width: 600px;
    padding-right: 10px;
  }
  .formatsdgs {
      padding-left: 20px;
      padding-right: 20px;
  }

  }
     
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .colsmall {
    width: 100%;
    padding-top: 200px;

  }
  .collarge {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
  .card {
    text-align: center;
    padding-left: 200px;
    padding-right: 100px;
  }
  .txtdata {
    margin-bottom: 30px;
    width: 700px;
    padding-right: 10px;
  }
}
    
     
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .collarge {
    width: 60%;
  }
  .colsmall {
    width: 40%;
    padding-top: 50px;
  }
  .leftsecs {
    margin-top: 50px;
  }
  .card {
    text-align: center;
    padding: 30px;

  }
  .txtdata {
    margin-bottom: 30px;
    width: 800px;
    padding-right: 10px;
  }
  .col-md-4 {
    margin-top: -100px;
  }

}
  
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .collarge {
    width: 60%;
  }
  .colsmall {
    width: 40%;
    padding-top: 50px;
  }
  .col-md-4 {
    margin-top: -100px;
  }
}
    
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
  .collarge {
    width: 70%;
  }
  .colsmall {
    width: 30%;
    padding-top: 50px;
  }
  .col-md-4 {
    margin-top: -100px;
  }
  }
    
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {
  
}
</style>